<chart-details-layout
  [chartDetails]="chartDetails"
  [isLoading]="isLoading"
  [showChartOrGrid]="false"
  [showFormButtons]="showFormButtons"
  (save)="onSaveSettings()"
  (cancel)="onRevertSettings()"
>
  <app-usage-base-grid grid [showTitle]="false"> </app-usage-base-grid>
  <base-details
    detailsComponent
    *ngIf="!isLoading"
    [chartDetails]="chartDetails"
    [generalSettings]="config?.generalSettings"
    (generalSettingsChange)="onGeneralSettingsChange($event)"
    [showSharedSettings]="false"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group input-group has-feedback" style="position: relative;">
          <label class="control-group input-group-addon" for="selectTimePeriod"
            >Time Period
              <button class="info-btn"
                      type="button"
                      [attr.title]="info('timePeriod')"
                      (click)="onInfoClick($event, 'timePeriod')">
                  i
              </button>
            </label
          >
          <select
            id="selectTimePeriod"
            name="selectTimePeriod"
            [(ngModel)]="selectedTimePeriod"
            class="form-control"
            (click)="hideTooltip()"
          >
            <option value="" [selected]="selectedTimePeriod === ''">
              -- Select Time Period --
            </option>
            <option *ngFor="let period of timePeriods" [value]="period.value">
              {{ period.display }}
            </option>
          </select>

          <div class="click-tooltip"
               *ngIf="isTooltipVisible('timePeriod')"
               (click)="hideTooltip()">
            {{ info('timePeriod') }}
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group input-group has-feedback" style="position: relative;">
          <label class="control-group input-group-addon" for="selectPermission"
            >User Permission
              <button class="info-btn"
                      type="button"
                      [attr.title]="info('userPermission')"
                      (click)="onInfoClick($event, 'userPermission')">
                  i
              </button>
            </label
          >
          <select
            id="selectPermission"
            name="selectPermission"
            [(ngModel)]="selectedPermission"
            class="form-control"
            (click)="hideTooltip()"
          >
            <option value="" [selected]="selectedPermission === 0">
              -- Select Permission --
            </option>
            <option
              *ngFor="let permission of userPermissions"
              [value]="permission.value"
            >
              {{ permission.display }}
            </option>
          </select>

          <div class="click-tooltip"
               *ngIf="isTooltipVisible('userPermission')"
               (click)="hideTooltip()">
            {{ info('userPermission') }}
          </div>
        </div>
      </div>
    </div>
  </base-details>
</chart-details-layout>
